import React, { useState, useRef, useEffect } from "react";
import general from "../../options/general.json";
import ReportsExpand from "../common/ReportsExpand";
import Select from "../common/Select";
import { getYearRangeAsArray } from "./../../scripts/helperScripts";

function CensusReport({ month, year, isFavorite, toggleFavorite, ...rest }) {
  const [reportData, setReportData] = useState({
    CensusDivision: "",
    CensusMonth: (new Date().getMonth() + 1).toString().replace(/^0+/, ""),
    CensusYear: new Date().getFullYear().toString(),
  });
  const isMountedRef = useRef(true);
  const [divisions, setDivisions] = useState([]);
  const reportOrg =
    process.env.REACT_APP_ENVIRONMENT === "Production"
      ? "SOARLive"
      : "SOARD365Base";

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  useEffect(() => {
    const userDivisions = JSON.parse(localStorage.getItem("safyInfo")).user
      .divisions;
    let divs = [];
    userDivisions.forEach((element) => {
      divs.push({ _id: element, name: element });
    });
    setDivisions(divs);
  }, []);

  const openReport = () => {
    const url = `https://safyreports.azurewebsites.net/Reports/Census/Division?db=${reportOrg}&div=${reportData.CensusDivision}&m=${reportData.CensusMonth}&y=${reportData.CensusYear}`;
    window.open(url, "Census Report");
  };

  const handleChange = ({ currentTarget: input }) => {
    console.log("input: ", input, input.value);
    const data = { ...reportData };
    data[input.name] = input.value;
    setReportData(data);
  };

  // const getCurrentMonth = () => {
  //   const d = new Date();
  //   const m = d.getMonth();
  //   alert((m + 1).toString());
  // };

  // getCurrentMonth();

  return (
    <ReportsExpand
      title="Division Census"
      isFavorite={isFavorite}
      toggleFavorite={toggleFavorite}
      {...rest}
    >
      <div className="row">
        <Select
          className="col col-4"
          name="CensusDivision"
          label="Division"
          options={divisions}
          value={reportData.CensusDivision}
          onChange={handleChange}
        />
        <Select
          className="col col-3"
          name="CensusMonth"
          label="Month"
          options={general.month}
          value={reportData.CensusMonth}
          onChange={handleChange}
        />
        <Select
          className="col col-3"
          name="CensusYear"
          label="Year"
          options={getYearRangeAsArray().map((year) => {
            const yearStr = `${year}`;
            return { _id: yearStr, name: yearStr };
          })}
          value={reportData.CensusYear}
          onChange={handleChange}
        />
        {reportData.CensusDivision !== "" &&
          reportData.CensusMonth !== "" &&
          reportData.CensusYear !== "" && (
            <i
              className="fas fa-arrow-circle-right fa-3x col col-2 float-end"
              onClick={openReport}
            ></i>
          )}
      </div>
    </ReportsExpand>
  );
}

export default CensusReport;
